import { ISession } from "@/interfaces"
import IPrescription from "@/interfaces/IPrescription"
import { defineStore } from "pinia"

export interface IState {
  session: ISession | null
  token: string | null
  prescription: IPrescription | null
}

const getStateFromStorage = (): IState => {
  const localState = localStorage.getItem(process.env.VUE_APP_STORAGE_KEY as string)
  const st: IState = JSON.parse(localState || '{}')
  const state: IState = {
    session: st.session,
    token: st.token,
    prescription: st.prescription,
  }
  return state
}

export const useMainStore = defineStore('main', {
  state: getStateFromStorage,
  getters: {
    getSession: (state) => state.session,
    getToken: (state) => state.token,
    getPrescription: (state) => state.prescription,
  },
  actions: {
    saveSession(session: ISession) {
      const newSession = { ...this.$state.session, ...session }
      this.$patch({ session: newSession })
      this.saveState()
    },
    saveToken(token: string) {
      this.$patch({ token })
      this.saveState()
    },
    savePrescription(prescription: Partial<IPrescription>) {
      this.$patch({ prescription })
      this.saveState()
    },
    clearPrescription() {
      this.$patch({ prescription: null })
      this.saveState()
    },
    clearSession() {
      this.$patch({ session: null, token: null })
      this.saveState()
    },
    saveState() {
      localStorage.setItem(process.env.VUE_APP_STORAGE_KEY as string, JSON.stringify(this.$state))
    },
  },
})